/**
 * Root component. All routes are declared here. As the app grows, split
 * this into a `routes.tsx` file with a route config array.
 *
 * The Header is `position: fixed` and overlays the hero scroll-video, so
 * it lives outside the routed `<main>` and doesn't push content down.
 */

import { Route, Routes } from "react-router-dom";

import { Header } from "@/components/layout/Header";
import HomePage from "@/pages/HomePage";
import LoginPage from "@/pages/LoginPage";
import NotFoundPage from "@/pages/NotFoundPage";

function App() {
  return (
    <div className="min-h-screen bg-slate-950 text-slate-50">
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>
    </div>
  );
}

export default App;
